import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { addProducts } from "../../api/products";
import { addUnit, getUNits } from "../../api/unit";

const AddProductModal = ({ show, handleClose }) => {
  const [unitData, setUnitData] = useState([]);
  const [newUnit, setNewUnit] = useState(false);
  const [unitName, setUnitName] = useState("");
  const [productName, setProductName] = useState("");
  const [prodUnit, setProdUnit] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  function handleVisibleNewUnit(event) {
    event.preventDefault();
    setNewUnit(true);
  }

  function handleCancelNewUnit(event) {
    event.preventDefault();
    setNewUnit(false);
    setUnitName("");
  }

  function handleUnitNameChange(e) {
    setUnitName(e.target.value);
  }

  function getUnitLists() {
    getUNits((result) => {
      if (result.ok === 1) {
        setUnitData(result.result);
      } else {
        setError("Failed to load units. Check your internet connection!");
      }
    });
  }

  function handleAddUnit(event) {
    event.preventDefault();
    if (!unitName.trim()) {
      setError("Unit name is required!");
      return;
    }

    setLoading(true);
    const unitDataObj = { unitName };
    
    addUnit(unitDataObj, (result) => {
      setLoading(false);
      if (result.ok === 1) {
        setSuccess("Unit added successfully!");
        setNewUnit(false);
        setUnitName("");
        getUnitLists();
        setTimeout(() => setSuccess(""), 3000);
      } else {
        setError("Failed to add unit. Check your internet connection!");
      }
    });
  }

  function handleChangeProductName(e) {
    setProductName(e.target.value);
  }

  function handleProdUnitChange(e) {
    setProdUnit(e.target.value);
  }

  function handleAddProduct(event) {
    event.preventDefault();
    setError("");
    setSuccess("");

    if (productName.length < 1) {
      return setError("Product Name is required");
    }
    if (prodUnit.length < 1) {
      return setError("Product Unit is required");
    }

    setLoading(true);
    const productData = {
      product_name: productName,
      prodUNit: prodUnit,
    };

    addProducts(productData, (result) => {
      setLoading(false);
      if (result.ok === 1) {
        setSuccess("Product added successfully!");
        setTimeout(() => {
          setProductName("");
          setProdUnit("");
          setSuccess("");
          handleClose();
        }, 1500);
      } else {
        console.log(productData);
        console.log(result);
        setError("Failed to add product. Check your internet connection!");
      }
    });
  }

  const clearForm = () => {
    setProductName("");
    setProdUnit("");
    setUnitName("");
    setNewUnit(false);
    setError("");
    setSuccess("");
  };

  useEffect(() => {
    getUnitLists();
  }, []);

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered backdrop="static">
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fw-bold text-dark">
          <i className="bi bi-box-seam me-2 text-success"></i>
          Add New Product
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {/* Alert Messages */}
        {error && (
          <div className="alert alert-danger border-0 rounded-3 d-flex align-items-center mb-3">
            <i className="bi bi-exclamation-triangle-fill me-2"></i>
            {error}
          </div>
        )}
        {success && (
          <div className="alert alert-success border-0 rounded-3 d-flex align-items-center mb-3">
            <i className="bi bi-check-circle-fill me-2"></i>
            {success}
          </div>
        )}

        <form onSubmit={handleAddProduct}>
          {/* Product Information Card */}
          <div className="card border-0 shadow-sm mb-4">
            <div className="card-header bg-success text-white border-0">
              <h6 className="mb-0 fw-bold">
                <i className="bi bi-box-seam me-2"></i>
                Product Information
              </h6>
            </div>
            <div className="card-body">
              {/* Product Name */}
              <div className="mb-4">
                <label className="form-label fw-semibold">
                  <i className="bi bi-tag me-2"></i>
                  Product Name <span className="text-danger">*</span>
                </label>
                <input
                  onChange={handleChangeProductName}
                  value={productName}
                  type="text"
                  className="form-control form-control-lg border-0 bg-light"
                  placeholder="Enter product name"
                  style={{ borderRadius: '12px' }}
                  required
                />
              </div>

              {/* Product Unit */}
              <div className="mb-0">
                <label className="form-label fw-semibold">
                  <i className="bi bi-rulers me-2"></i>
                  Product Unit <span className="text-danger">*</span>
                </label>
                
                {newUnit ? (
                  <div className="card border-0 bg-warning bg-opacity-10">
                    <div className="card-body">
                      <h6 className="fw-bold mb-3 text-warning">
                        <i className="bi bi-plus-circle me-2"></i>
                        Add New Unit
                      </h6>
                      <div className="input-group mb-3">
                        <input 
                          className="form-control form-control-lg border-0 bg-white" 
                          placeholder="Enter unit name (e.g., kg, pieces, liters)" 
                          onChange={handleUnitNameChange}
                          value={unitName}
                          style={{ borderRadius: '12px 0 0 12px' }}
                          required
                        />
                        <button 
                          className="btn btn-success px-3" 
                          onClick={handleAddUnit}
                          disabled={loading}
                          style={{ borderRadius: '0 12px 12px 0' }}
                        >
                          {loading ? (
                            <span className="spinner-border spinner-border-sm"></span>
                          ) : (
                            <>
                              <i className="bi bi-check-lg me-1"></i>
                              Add
                            </>
                          )}
                        </button>
                      </div>
                      <button 
                        className="btn btn-outline-secondary btn-sm" 
                        onClick={handleCancelNewUnit}
                      >
                        <i className="bi bi-x-circle me-1"></i>
                        Cancel
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="input-group">
                    <select 
                      onChange={handleProdUnitChange} 
                      value={prodUnit}
                      className="form-select form-select-lg border-0 bg-light"
                      style={{ borderRadius: '12px 0 0 12px' }}
                      required
                    >
                      <option value="">Select unit...</option>
                      {unitData.map((item, index) => (
                        <option key={index} value={item.name}>{item.name}</option>
                      ))}
                    </select>
                    <button 
                      className="btn btn-primary px-3" 
                      onClick={handleVisibleNewUnit}
                      type="button"
                      style={{ borderRadius: '0 12px 12px 0' }}
                    >
                      <i className="bi bi-plus-lg"></i>
                    </button>
                  </div>
                )}
                <small className="text-muted mt-1 d-block">
                  <i className="bi bi-info-circle me-1"></i>
                  Select an existing unit or add a new one
                </small>
              </div>
            </div>
          </div>

          {/* Selected Information Summary */}
          {(productName || prodUnit) && (
            <div className="card border-0 bg-primary bg-opacity-10 mb-4">
              <div className="card-body">
                <h6 className="fw-bold mb-2 text-primary">
                  <i className="bi bi-eye me-2"></i>
                  Preview
                </h6>
                <div className="d-flex align-items-center">
                  <div className="bg-primary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3" style={{width: '40px', height: '40px'}}>
                    <i className="bi bi-box text-primary"></i>
                  </div>
                  <div>
                    <div className="fw-semibold">{productName || "Product Name"}</div>
                    <small className="text-muted">Unit: {prodUnit || "Not selected"}</small>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Action Buttons */}
          <div className="d-flex gap-3 justify-content-end">
            <button
              type="button"
              onClick={() => {
                clearForm();
                handleClose();
              }}
              className="btn btn-outline-secondary btn-lg px-4"
              style={{ borderRadius: '12px' }}
              disabled={loading}
            >
              <i className="bi bi-x-circle me-2"></i>
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-success btn-lg px-4"
              style={{ borderRadius: '12px' }}
              disabled={loading || newUnit}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Adding Product...
                </>
              ) : (
                <>
                  <i className="bi bi-plus-circle me-2"></i>
                  Add Product
                </>
              )}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddProductModal;